class ClipBackgroundImage extends HTMLElement {
  connectedCallback() {
    this.right = this.dataset.right;
    this.left = this.dataset.left;
    this.bottom = this.dataset.bottom;
    this.top = this.dataset.top;
    const w = this.clientWidth;
    const h = this.clientHeight;

    this.right && (this.style.right = `${w * +this.right}px`);
    this.left && (this.style.left = `${w * +this.left}px`);
    this.bottom && (this.style.bottom = `${h * +this.bottom}px`);
    this.top && (this.style.top = `${h * +this.top}px`);
  }
}

customElements.define("clip-background-image", ClipBackgroundImage);
